<!-- 由 suu 创建于 2022-09-02 星期五 -->
<template>
  <div class="week-summary-list" v-if="list && list.length">
    <div class="sl-item" v-for="(item, index) in list" :key="index">
      <div class="i-left">
        <div class="l-title">{{ item.weekly_name }}</div>
        <div class="l-date"
          >生成时间：{{ item.created_at.split(' ')[0].replace(/-/g, '.') }}
          <span>营期：{{ item.alias }}</span>
        </div>
      </div>
      <div class="i-btn user-btn" @click="handleClick(item)">查看</div>
    </div>
  </div>
  <van-empty description="暂无" v-else />
</template>

<script>
export default {
  name: 'week-summary-list',

  components: {},

  props: {},

  data() {
    return {
      // 75135
      uid: this.$route.query.uid,
      pid: this.$route.query.pid,
      page: 0,
      pageSize: 100,
      list: []
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getList()
  },

  mounted() {},

  destroyed() {},

  methods: {
    handleClick(item) {
      this.$router.push('/week-summary?id=' + item.id)
    },
    getList() {
      this.$http
        .getApp('member/CampWeekly/getWeeklyList', {
          uid: this.uid,
          pid: this.pid,
          pageSize: this.pageSize
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.list = res.data.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.week-summary-list {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  background: #f9f9f9;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .sl-item {
    width: 335px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    .i-left {
      flex: 1;
      .l-title {
        font-size: 15px;
        font-weight: 500;
        color: #000000;
      }
      .l-date {
        margin-top: 6px;
        font-size: 11px;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: start;
        span {
          margin-left: 8px;
        }
      }
    }
    .i-btn {
      width: 64px;
      height: 25px;
      box-sizing: border-box;
      margin-left: 10px;
      background: rgba(98, 54, 255, 0.1);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 400;
      color: #6236ff;
    }
  }
}
</style>
